export default __webpack_public_path__ + "static/media/about.e51c42cf.jpg";